import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

export default ({
	children = "Text",
	placement = "top",
	id = "tooltip",
	content = "content",
	trigger = ["hover"],
	rootClose = false
}) => {
	const tooltip = <Tooltip id={id}>{content}</Tooltip>;

	return (
		<OverlayTrigger placement={placement} trigger={trigger} overlay={tooltip} rootClose={rootClose}>
			{children}
		</OverlayTrigger>
	);
};
